/**
 * Clients page — filter the logo grids by sector.
 * "Tout" shows every sector group; a sector tab shows only its group.
 */
const initClientsLogos = (section) => {
  const tabs = Array.from(section.querySelectorAll('[data-clients-filter]'));
  const groups = Array.from(section.querySelectorAll('[data-clients-sector]'));

  if (!tabs.length || !groups.length) {
    return;
  }

  const activate = (filter) => {
    tabs.forEach((tab) => {
      const isActive = tab.dataset.clientsFilter === filter;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    groups.forEach((group) => {
      const show = filter === 'all' || group.dataset.clientsSector === filter;
      group.hidden = !show;
    });
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => activate(tab.dataset.clientsFilter));
  });
};

const initAll = () => {
  document.querySelectorAll('[data-clients-logos]').forEach((section) => {
    if (section.dataset.clientsLogosInitialized) {
      return;
    }

    section.dataset.clientsLogosInitialized = 'true';
    initClientsLogos(section);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}
